import { captureException, startSpan } from "@sentry/react";

import {
    EditLootGenerationRequest,
    ILootGenerationResponse,
    LootGenerationRequest,
    LootGenerationResponseDTO,
} from "../../types";
import { doGet, doPostJson, doPutJson } from "../core/http";

export const generateLoot = async (
    lootData: LootGenerationRequest
): Promise<ILootGenerationResponse> => {
    try {
        const { data, error } = await startSpan(
            { name: "generateLoot" },
            async () => {
                return await doPostJson("/api/loot/generate", true, lootData);
            }
        );

        if (error) {
            captureException(error);
            return { error: error.message };
        }

        return { response: data };
    } catch (e) {
        captureException(e);
        return { error: "Failed to generate loot." };
    }
};

export const getLoot = async (id: string): Promise<ILootGenerationResponse> => {
    try {
        const response = await startSpan({ name: "getLoot" }, async () => {
            return await doGet(`/api/loot/${id}`, true);
        });

        if (response.error) {
            captureException(response.error);
            return { error: response.error };
        }

        return { response: response.data };
    } catch (e) {
        captureException(e);
        return { error: "Failed to get loot." };
    }
};

export const editLoot = async (
    id: string,
    lootData: EditLootGenerationRequest
): Promise<{ response?: LootGenerationResponseDTO; error?: string }> => {
    try {
        const { data, error } = await startSpan(
            { name: "editLoot" },
            async () => {
                return await doPutJson(`/api/loot/${id}`, true, lootData);
            }
        );

        if (error) {
            captureException(error);
            return { error: error.message };
        }

        return { response: data };
    } catch (error: any) {
        captureException(error);
        return { error: error.message };
    }
};
